<!-- Main content -->
<div class="domain-search-result-container p-3 px-md-5 mb-3">
  <div class="px-0 px-xl-4">
    <ng-container *ngTemplateOutlet="!domain || !(domain.available) ? unavailableDomainTemplate : availableDomainSelectTemplate"></ng-container>
  </div>
</div>

<!--  Available Domain Select Template -->
<ng-template #availableDomainSelectTemplate>
  <ng-container *ngIf="domain.isAvailableOffline; then availableOfflineDomainTemplate else availableDomainTemplate"></ng-container>
</ng-template>

<!--  Available Domain Template -->
<ng-template #availableDomainTemplate>

  <div class="basic-domain-result-text">
    <b>{{'¡Excelente!'| translate }}</b> {{'el dominio está disponible.'| translate }} <b>
      {{'Regístralo'| translate }}
    </b> {{'antes de que te lo ganen'| translate }}.
  </div>

  <hr *ngIf="!hasDomainPackages">

  <div class="row w-100 justify-content-between align-items-center p-0 mx-0 my-3">

    <!-- Domain name -->
    <div class="domain-name-container col-12 col-lg-5 d-block d-md-inline text-center text-lg-start m-0 p-0">
      <span class="fs-xl black">
        {{ domain.domainName }}
      </span>
      
    </div>

    <!-- Price, requirements and add to cart -->
    <div class="col-12 col-lg-7 d-flex flex-column flex-lg-row justify-content-center justify-content-lg-end align-items-center p-0 m-0">

      <div class="mt-3 mt-md-0 pe-0 pe-xl-5">
        <!-- Add to cart button -->
        <button id="searchDomainForm_domainResults_0" (click)="onSelectDomain()" [disabled]="!(domain.isEnabled)"
                class="btn mx-auto ms-md-0 text-nowrap btn-primary">
          {{'Seleccionar' | translate}}
        </button>

      </div>
    </div>

  </div>

</ng-template>

<!--  Unavailable Domain Ttemplate -->
<ng-template #unavailableDomainTemplate>
  <div *ngIf="!(domain?.available)" class="d-flex align-items-center">
    <div *ngIf="domain && domain?.domainName && domain?.domainName !== ''">
      <span class="searchResult-error-description">{{'El dominio' | translate}}</span>
      <span class="basic-domain-result-text domain-name-error-container mx-1"><b>{{ domain?.domainName }}</b></span>
      <span class="searchResult-error-description">{{'no está disponible' | translate}}.</span>
    </div>
    <div *ngIf="!domain || !domain?.domainName || domain?.domainName === ''">
      <span class="searchResult-error-description">{{'El dominio no está disponible' | translate}}.</span>
    </div>
  </div>

  <ng-container *ngTemplateOutlet="domainErrorTemplate; context: { domain: domain }"></ng-container>
</ng-template>

<!--  AvailableOffline Domain Ttemplate -->
<ng-template #availableOfflineDomainTemplate>
  <div *ngIf="(domain?.isAvailableOffline)" class="d-flex align-items-center">
    <div *ngIf="domain && domain?.domainName && domain?.domainName !== ''">
      <span class="searchResult-error-description">{{'El dominio' | translate}}</span>
      <span class="basic-domain-result-text domain-name-error-container mx-1"><b>{{ domain?.domainName }}</b></span>
      <span class="searchResult-error-description">
        {{'está disponible fuera de línea' | translate}}.
        <span class="col-12 col-sm-6 help-icon-container">
          <img loading="lazy" data-src="{{ '/icons/Colores/question-circle-green.svg' | blobstorage }}"
               alt="Question mark" src="{{ '/icons/Colores/question-circle-green.svg' | blobstorage }}">
          <span class="tooltipTextSearchDomainOffline">
            <small>
              {{
'Favor de contactar a Servicio al Cliente' |
              translate
              }}
            </small>
          </span>
        </span>
      </span>

    </div>
    <div *ngIf="!domain || !domain?.domainName || domain?.domainName === ''">
      <span class="searchResult-error-description">
        {{'El dominio está disponible fuera de línea' | translate}}.
        <span class="col-12 col-sm-6 help-icon-container">
          <img loading="lazy" data-src="{{ '/icons/Colores/question-circle-green.svg' | blobstorage }}"
               alt="Question mark" src="{{ '/icons/Colores/question-circle-green.svg' | blobstorage }}">
          <span class="tooltipTextSearchDomainOffline">
            {{
'Favor de contactar a Servicio al Cliente' |
            translate
            }}
          </span>
        </span>
      </span>
    </div>
  </div>

  <ng-container *ngTemplateOutlet="domainErrorTemplate; context: { domain: domain }"></ng-container>
</ng-template>

<!-- Domain error template -->
<ng-template #domainErrorTemplate let-domain="domain">
  <p class="searchResult-error-description p-0 m-0" *ngIf="hasError(domain)">
    <span *ngIf="!isMaintenanceError()">
      {{ 'Verifica su escritura.' | translate }}
      <span class="col-12 col-sm-6 help-icon-container">
        <img loading="lazy" data-src="{{ '/icons/Colores/question-circle-green.svg' | blobstorage }}"
             alt="Question Mark" src="{{ '/icons/Colores/question-circle-green.svg' | blobstorage }}">
        <span class="tooltipTextSearchDomain"><small> {{ getDomainErrorMessage() }} </small></span>
      </span>
    </span>
    <span class="maintenance-error" *ngIf="isMaintenanceError()">
      {{getDomainErrorMessage() }}
      <span class="text-underline clickable black" (click)="navigateToPortalAkky()">
        {{ 'Más Información' | translate }}.
      </span>
    </span>
  </p>
</ng-template>

<!-- Domain Promotion Template -->
<ng-template #promotionTemplate let-domainPackage="domainPackage">
  <hr>
  <div class="d-block d-lg-flex w-100 align-items-center price-button-container pe-0 pe-xl-5 d-none">
    <div class="flex-grow-1 me-0 me-md-2 me-lg-5" [innerHTML]="domainPackageHTML(domainPackage) | safe: 'html'"></div>
    <div class="d-flex align-self-end mt-3 mt-md-0">
      <button (click)="onaddToCart(domainPackage)" [disabled]="!(domain.isEnabled)"
              class="btn btn-primary text-nowrap mx-auto ms-md-0">
        {{'Agregar al carrito' | translate}}
      </button>
    </div>
  </div>
</ng-template>
